/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_login_show_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show password`)
};

const zh_hans1_login_show_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示密码`)
};

const zh_hant1_login_show_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`顯示密碼`)
};

const fr_login_show_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher le mot de passe`)
};

const de_login_show_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort anzeigen`)
};

const ja_login_show_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードを表示`)
};

const ko_login_show_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비밀번호 표시`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const login_show_password = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.login_show_password(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("login_show_password", locale)
	if (locale === "en") return en_login_show_password(inputs)
	if (locale === "zh-Hans") return zh_hans1_login_show_password(inputs)
	if (locale === "zh-Hant") return zh_hant1_login_show_password(inputs)
	if (locale === "fr") return fr_login_show_password(inputs)
	if (locale === "de") return de_login_show_password(inputs)
	if (locale === "ja") return ja_login_show_password(inputs)
	return ko_login_show_password(inputs)
};